import { HistoryTerm } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';

export class LoadQueryHistoryAction implements HistoryAction {

  actions = {
    [HISTORY_ACTIONS_KEYS.loadQueryHistory]: ({ commit, getters }: HistoryContext): any => {
      const storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      this.removePreviousVersions(getters.version, storageService);
      const history = storageService.getItem<HistoryTerm[]>(getters.storageKey);
      commit(HISTORY_MUTATIONS_KEYS.setQueryHistory, history || []);
      let enabledHistory = storageService.getItem<boolean>('enabled_history');
      enabledHistory = enabledHistory === null ? true : enabledHistory;
      commit(HISTORY_MUTATIONS_KEYS.setEnabledQueryHistory, enabledHistory);
    }
  };

  private removePreviousVersions(version: number, storageService: StorageService) {
    for (let i = 0; i < version; i++) {
      const key = `history${ i ? '_' + i : '' }`;
      storageService.removeItem(key);
    }
  }
}
